import {ConfigService, ErrorsService, Notification, ModelsList, StoreService} from 'shared';
import {Observable, Subject} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class NotificationService extends StoreService<Notification> {

  public navigation = new Subject<Notification>();

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(Notification);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<Notification>> {
    return this.http.get<ModelsList<Notification>>(this.config.apiVerUrl('/app/notifications'), {params: queryParams});
  }

  protected insert(values: Notification): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/notifications'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/notifications/${id}`));
  }

  public update(id, values: Notification): Observable<Notification> {
    return this.http.put<Notification>(this.config.apiVerUrl(`/app/notifications/${id}`), values);
  }

  public readAll(): Observable<boolean> {
    return this.http.get<boolean>(this.config.apiVerUrl('/app/notifications/read-all'));
  }
}
